import api from '@/utils/api';

export const QueryFeeCustomer = data => {
    return api.post(`/expenseStandardCustomer/getExpenseStandardCustomerPage`, data);
};

export const QueryFeeDetail = data => {
    return api.post(`/expenseRecord/getExpenseRecordPage`, data);
};

// 月费用
export const QueryMonthFee = data => {
    return api.post(`/expenseStandardCustomerMonth/getExpenseStandardCustomerMonthAllVoPage`, data);
};

export const AddMonthFee = data => {
    return api.post(`/expenseStandardCustomerMonth/addExpenseStandardCustomerMonth`, data);
};

export const UpdateMonthFee = data => {
    return api.post(`/expenseStandardCustomerMonth/updateExpenseStandardCustomerMonth`, data);
};

export const DeleteMonthFee = ({ standardId }) => {
    return api.get(`/expenseStandardCustomerMonth/deleteExpenseStandardCustomerMonth/${standardId}`);
};

export const QueryMonthFeeDetail = data => {
    return api.post(`/expenseStandardCustomerMonth/getExpenseStandardCustomerMonthVoPage`, data);
};
export const QueryMonthFeeDetailInfo = ({ standardId }) => {
    return api.get(`/expenseStandardCustomerMonth/getExpenseStandardCustomerMonthInfoById/${standardId}`);
};

export const QueryFeeOther = data => {
    return api.post(`/expenseStandardCustomer/getExpenseStandardCustomerInfo`, data);
};

export const QueryAreaOther = data => {
    return api.post(`/expenseStandardArea/getExpenseStandardAreaSurplusByCustomer`, data);
};

//总览

export const QueryMainFee = data => {
    return api.post(`/expenseStandardCustomer/getExpenseOverviewPage`, data);
};

// 已花费费用
export const AddUseFee = data => {
    return api.post(`/expenseRecord/addExpenseRecordDirect`, data);
};

export const AddNormalUseFee = data => {
    return api.post(`/expenseRecord/addExpenseRecord`, data);
};

export const UpdateUseFee = data => {
    return api.post(`/expenseRecord/updateExpenseRecordDirect`, data);
};

export const UpdateNormalUseFee = data => {
    return api.post(`/expenseRecord/updateExpenseRecord`, data);
};

export const UpdateUseFeeResult = data => {
    return api.post(`/expenseRecord/updateExpenseRecordResult`, data);
};

// 区域费用
export const QueryAreaFee = data => {
    return api.post(`/expenseStandardArea/getExpenseStandardAreaVoList`, data);
};

export const SaveAreaFee = data => {
    return api.post(`/expenseStandardArea/saveExpenseStandardArea`, data);
};

// 个人费用
export const QueryUserFee = data => {
    return api.post(`/expenseStandardUser/getExpenseStandardUserPage`, data);
};

export const UpdateUserFee = data => {
    return api.post(`/expenseStandardUser/updateExpenseStandardUser`, data);
};

export const SaveUserFee = data => {
    return api.post(`/expenseStandardUser/addExpenseStandardUser`, data);
};

export const QueryExpenseFee = data => {
    return api.post(`/expenseReimburse/getExpenseReimburse4ManageUserWithSelfPage`, data);
};

export const QueryExpenseFeeInfo = ({ reimburseId }) => {
    return api.get(`/expenseReimburse/getExpenseReimburseDetail/${reimburseId}`);
};

export const QueryExpenseRecordInfo = ({ reimburseId }) => {
    return api.get(`/expenseRecord/getExpenseRecordVoByReimburseId/${reimburseId}`);
};

export const QueryGationInfo = ({ reimburseId }) => {
    return api.get(`/expenseRecord/getExpenseRecordAggregationByByReimburseId/${reimburseId}`);
};

export const UpdateFeeVerfiyFlag = ({ recordId }) => {
    return api.get(`/expenseRecord/updateExpenseRecord4Verify/${recordId}`);
};

export const DeleteFeeRecord = ({ recordId }) => {
    return api.get(`/expenseRecord/deleteExpenseRecordById/${recordId}`);
};
